export default __webpack_public_path__ + "44553ce1adf906619c88ff6025843f93.svg";